module.exports = __webpack_public_path__ + "static/media/Dashboard.a9869887.svg";